<!-- 工单列表 -->

<template>
  <div>
    <div>
        <h4 style="margin-top:40px;" title="处理人为我或我创建的或抄送给我的未关闭的工单">工单</h4>
    </div>
    <div
        style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
        v-for="each in ticketList"
        :key="each.id">
        <span>{{each.createdAt|ticketTime}}</span>
        <a :href="'/ticket/t/' + each.orderId" style="color: #409eff;">{{each.orderId}} {{each.orderTitle}}</a>
        <span>{{each.operateContent}}</span>
        <span v-if="each.assignUserId">
            给
            <TicketUser :userId="each.assignUserId"/>
        </span>
    </div>

    <div v-if="!ticketList || ticketList.length < 1">ticketList is null or empty ...</div>

    <el-pagination
        style="padding-top:20px;"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :pager-count="6"
        :current-page="ticketPage.pageNumber" 
        :page-sizes="[10, 25, 35, 50, 100]" 
        :page-size="ticketPage.pageSize" 
        :total="ticketPage.recordCount || 0" 
        @size-change="handleSizeChange_Ticket" 
        @current-change="listTicket" />
  </div>
</template>

<script>
export default {
    name: 'UserTicketList',

    props: ['userId'],

    data() {
        return {
            createdAtGe: null,
            createdAtLe: null,

            ticketList : [],

            ticketPage : {
                pageNumber: 1,
                pageSize: 20,
                orderBy: "`create_time` DESC"
            }
        }
    },

    watch: {
        userId() {
            this.listTicket(1);
        }
    },

    methods: {
        handleSizeChange_Ticket( pageSize ) {
            this.ticketPage.pageSize = pageSize;

            this.listTicket();
        },

        listTicket( _pageNumber ) {
            if ( !this.userId ) {
                console.log('#71 listTicket this.userId = ', this.userId);
                return;
            }

            var _this = this;
            _this.ticketPage.pageNumber = _pageNumber;

            var andItems = [{'$is_not_null': 'orderId'}];

            if ( 'ALL' != this.userId ) {
                andItems.push({"$or": [
                    {"$eq": {"dealUserId": this.userId}}, 
                    {"$ticket_cc_to": this.userId}, 
                    {"$eq": {"creatorId": this.userId}}
                ]});
            }

            if ( !!_this.createdAtGe ) {
                andItems.push({'$ge': {'create_time': _this.createdAtGe}})
                andItems.push({'$le': {'create_time': _this.createdAtLe}})
            }

            sdk.TicketApi().list({
                filter : {"$and": andItems},
                page : _this.ticketPage
            }).then(res => {
                _this.ticketList = res.list;
                _this.ticketPage.recordCount = res.recordCount;
            });
        },

        listTicket_1(createdAtGe, createdAtLe) {
            this.createdAtGe = createdAtGe;
            this.createdAtLe = createdAtLe;

            this.listTicket(1);
        }
    },

    mounted() {
        this.listTicket(1);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/UserTicketList.vue